import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import PropTypes from'prop-types';import styled from'styled-components';import noop from'../../utils/noop.js';var StyledForm = /*#__PURE__*/styled.form.withConfig({
  displayName: "Form__StyledForm",
  componentId: "sntzww-0"
})(["", ""], function (props) {
  return !props.fullWidth ? "max-width: 414px;" : '';
});
var focusFirstInvalidElement = function focusFirstInvalidElement() {
  var firstInvalidElement = document.querySelector(':not(form):not(fieldset):invalid');
  // eslint-disable-next-line no-unused-expressions
  firstInvalidElement === null || firstInvalidElement === void 0 ? void 0 : firstInvalidElement.focus(); // NOSONAR
};

var FormContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Form__FormContainer",
  componentId: "sntzww-1"
})(["max-width:414px;"]);
var Form = function Form(_ref) {
  var onSubmit = _ref.onSubmit,
    errorOnSubmit = _ref.errorOnSubmit,
    children = _ref.children,
    fullWidth = _ref.fullWidth,
    rest = _objectWithoutProperties(_ref, ["onSubmit", "errorOnSubmit", "children", "fullWidth"]);
  var handleSubmit = function handleSubmit(event) {
    var _event$target;
    // eslint-disable-next-line no-unused-expressions
    event === null || event === void 0 ? void 0 : event.preventDefault(); // NOSONAR
    var isValid = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.checkValidity();
    if (!isValid) {
      errorOnSubmit(true);
      focusFirstInvalidElement();
      return;
    }
    onSubmit(event);
  };
  return /*#__PURE__*/React.createElement(StyledForm, _extends({
    noValidate: true
  }, rest, {
    fullWidth: fullWidth,
    onSubmit: handleSubmit
  }), children);
};
process.env.NODE_ENV !== "production" ? Form.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  errorOnSubmit: PropTypes.func
} : void 0;
Form.defaultProps = {
  fullWidth: true,
  errorOnSubmit: noop
};
var Form$1 = Form;export{FormContainer,Form$1 as default};